import { useAuth } from './useAuth';
import { useImpersonationStore } from '@/stores/impersonationStore';
import { isKubicleAllowlisted } from '@/config/features';
import { useFeature } from './useFeature';

/**
 * Whether the EFFECTIVE viewer may use the Kubicle beta features.
 *
 * Source of truth is now the DB-backed `kubicle` feature flag (managed from
 * /admin/features), resolved server-side and delivered via GET /api/me. The
 * legacy hardcoded `KUBICLE_ALLOWLIST` (config/features.ts) is kept as a
 * FALLBACK so the original users can't lose access during migration.
 *
 * Both sources are impersonation-aware: features[] reflects the impersonated
 * user (App refetches /me on impersonation toggle), and the email fallback uses
 * the impersonated email — so admin "View As" shows the impersonated user's
 * Kubicle access either way.
 */
export function useKubicleAllowed(): boolean {
  const { user } = useAuth();
  const isImpersonating = useImpersonationStore(s => s.isImpersonating);
  const impersonatedEmail = useImpersonationStore(s => s.impersonatedUser?.email);
  const email = isImpersonating ? impersonatedEmail : user?.email;
  return useFeature('kubicle', isKubicleAllowlisted(email));
}
